import React, { useState } from "react";

export default function DeliveryMethod() {
    const [deliveryMethod, setDeliveryMethod] = useState("DELIVERY_PLATFORM_NORMAL");
    const [singleShipping, setSingleShipping] = useState(true);

    return (
        <div id="delivery__info_method" className="styles_wMax__iGEzJ">
            <div className="MuiPaper-root styles_root__NL0Ar MuiPaper-elevation0 MuiPaper-rounded">

                <h1 className="styles_title__c9FhR">
                    Lựa chọn hình thức giao hàng
                </h1>

                {/* === RADIO CHỌN PHƯƠNG THỨC GIAO === */}
                <fieldset className="MuiFormControl-root">
                    <div className="MuiFormGroup-root" role="radiogroup">

                        {/* OPTION 1: giao hàng tiêu chuẩn */}
                        <label
                            className={`MuiFormControlLabel-root ${deliveryMethod === "DELIVERY_PLATFORM_NORMAL"
                                ? "active_delivery"
                                : ""
                                }`}
                        >
                            <span
                                className={
                                    "MuiButtonBase-root MuiIconButton-root jss1 MuiRadio-root styles_checkbox_color__I_LkQ MuiRadio-colorSecondary jss2 " +
                                    (deliveryMethod === "DELIVERY_PLATFORM_NORMAL" ? "Mui-checked MuiIconButton-colorSecondary" : "")
                                }
                            >
                                <span className="MuiIconButton-label">
                                    <input
                                        className="jss4"
                                        type="radio"
                                        name="delivery-radio"
                                        value="DELIVERY_PLATFORM_NORMAL"
                                        checked={deliveryMethod === "DELIVERY_PLATFORM_NORMAL"}
                                        onChange={() => setDeliveryMethod("DELIVERY_PLATFORM_NORMAL")}
                                    />

                                    {/* Outer circle */}
                                    <div className="jss5 jss7">
                                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" viewBox="0 0 24 24">
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"></path>
                                        </svg>

                                        {/* Filled circle */}
                                        <svg className="MuiSvgIcon-root jss6 MuiSvgIcon-fontSizeSmall" viewBox="0 0 24 24">
                                            <path d="M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"></path>
                                        </svg>
                                    </div>
                                </span>
                            </span>

                            <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                <div className="styles_info__HNFD6">
                                    <div className="styles_colLeft__bTpDB">
                                        <b className="styles_fw500__l1726">Giao hàng tiêu chuẩn</b>
                                        <span className="styles_checkout_description__lyJea">
                                            Dự kiến nhận vào Thứ tư (31/12/2025)
                                        </span>
                                    </div>
                                </div>
                            </span>
                        </label>

                    </div>
                </fieldset>

                {/* ==== BOX CHIA ĐƠN HÀNG ==== */}
                <div className="MuiPaper-root MuiAlert-root MuiAlert-standardInfo styles_boxSplitOrder__fNveK MuiPaper-elevation0" role="alert">
                    <div className="MuiAlert-message">

                        <div className="MuiGrid-root MuiGrid-container">

                            <div className="MuiGrid-root styles_info__HNFD6 MuiGrid-item MuiGrid-grid-xs-12">
                                <h6 className="MuiTypography-root styles_textLeft__QPuss MuiTypography-h6">
                                    Để đơn hàng đến tay bạn nhanh nhất, chúng tôi có thể sẽ chia đơn hàng thành 2 lần giao.
                                    Tuy nhiên, nếu bạn muốn nhận đơn hàng trong 1 lần duy nhất, vui lòng nhấn vào ô dưới đây.
                                </h6>
                            </div>

                            {/* checkbox chọn giao 1 lần */}
                            <div className="MuiGrid-root styles_rowInfo__e2Y4E MuiGrid-item MuiGrid-grid-xs-12">

                                <p className="MuiTypography-root styles_textSplitOrder__s_9Qk MuiTypography-body1">
                                    <label className="MuiFormControlLabel-root">

                                        <span
                                            className={
                                                "MuiButtonBase-root MuiIconButton-root jss1 MuiCheckbox-root styles_checkbox__zxnw5 MuiCheckbox-colorSecondary jss2 " +
                                                (singleShipping ? "Mui-checked MuiIconButton-colorSecondary" : "")
                                            }
                                        >
                                            <span className="MuiIconButton-label">
                                                <input
                                                    className="jss4"
                                                    type="checkbox"
                                                    checked={singleShipping}
                                                    onChange={() => setSingleShipping(prev => !prev)}
                                                />

                                                <svg className="MuiSvgIcon-root" viewBox="0 0 24 24">
                                                    <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
                                                </svg>
                                            </span>
                                        </span>

                                        <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                            Tôi muốn nhận đơn hàng trong 1 lần giao.
                                        </span>
                                    </label>
                                </p>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
